import { useChargingFeePeakTypeEnumText } from '@services/chargingFee'
import { Select, SelectProps } from '@shared/Form/Select'

export const ChargingFeePeakTypeSelect = (props: SelectProps<number[]>) => {
  const { toText, ChargingFeePeakTypeEnum } = useChargingFeePeakTypeEnumText()

  return (
    <Select allowClear {...props}>
      {(Object.entries(ChargingFeePeakTypeEnum) || []).map(([key, value]) => (
        <Select.Option key={value} value={value}>
          {toText(value)}
        </Select.Option>
      ))}
    </Select>
  )
}

export default ChargingFeePeakTypeSelect
